import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getMyMetaSiteProfileRequest = {};
var _getMyMetaSiteProfileResponse = {};
var _getMyUserProfileRequest = {};
var _getMyUserProfileResponse = {};
var _getProfileRequest = {};
var _getProfileResponse = {};
function resolveWixBiProfileV4ProfileClientUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/wix-profile-client',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-profile-client',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/wix-profile-client',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/wix-profile-client',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/wix-profile-client',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/wix-profile-client',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/wix-profile-client',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get a Profile by user id or metasite id (signed server request) */
export function getProfile(payload) {
    var _a = serializer(_getProfileRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProfileResponse, {}).fromJSON;
    function __getProfile(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data_services.profile_client.v4.profile_field_data',
            method: 'POST',
            methodFqn: 'wix.bi.profile.v4.ProfileClient.GetProfile',
            url: resolveWixBiProfileV4ProfileClientUrl({
                protoPath: '/v4/profile',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProfile.fromReq = fromReq;
    return __getProfile;
}
/** Get a Profile by user id (Wix user - account contributor permissions) */
export function getMyUserProfile(payload) {
    var _a = serializer(_getMyUserProfileRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMyUserProfileResponse, {}).fromJSON;
    function __getMyUserProfile(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data_services.profile_client.v4.profile_field_data',
            method: 'POST',
            methodFqn: 'wix.bi.profile.v4.ProfileClient.GetMyUserProfile',
            url: resolveWixBiProfileV4ProfileClientUrl({
                protoPath: '/v4/profile/user',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMyUserProfile.fromReq = fromReq;
    return __getMyUserProfile;
}
/** Get a Profile by metasite id (Wix user - metasite contributor permissions) */
export function getMyMetaSiteProfile(payload) {
    var _a = serializer(_getMyMetaSiteProfileRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMyMetaSiteProfileResponse, {}).fromJSON;
    function __getMyMetaSiteProfile(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data_services.profile_client.v4.profile_field_data',
            method: 'POST',
            methodFqn: 'wix.bi.profile.v4.ProfileClient.GetMyMetaSiteProfile',
            url: resolveWixBiProfileV4ProfileClientUrl({
                protoPath: '/v4/profile/metasite',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMyMetaSiteProfile.fromReq = fromReq;
    return __getMyMetaSiteProfile;
}
//# sourceMappingURL=http.impl.js.map